exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{margin:8mm}[dir] body,html[dir]{margin:0!important;padding:0!important}.no-print{display:none!important}.print-only{display:block!important}[dir] .panel-body,[dir] .panel-heading{padding:0!important}.table{width:100%!important;table-layout:fixed!important;border-collapse:collapse!important;font-size:8pt!important;word-break:break-word}.table td,.table th{font-size:8pt!important;overflow:hidden}[dir] .table td,[dir] .table th{padding:3px 4px!important}.col-sub{font-size:6pt!important}}.print-only{display:none}.table{table-layout:fixed;width:100%}.col-sub,.table td,.table th{word-wrap:break-word;overflow-wrap:break-word}.col-sub{display:block;font-weight:400;font-size:10px;opacity:.85;line-height:1.2;white-space:normal}[dir] .col-sub{margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b958243","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/ordersReport.vue
// module id = 1093
// module chunks = 0